
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const GuestRoute = ({ children }) => {
    const { currentUser, loading } = useAuth();

    if (loading) {
        return <div className="loading-fullscreen">Loading...</div>;
    }

    if (currentUser) {
        return <Navigate to="/home" replace />;
    }

    return <>{children}</>;
};

export default GuestRoute;
